function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotFound = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 501,
  height: 194,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#F7F8FA",
  fillRule: "evenodd",
  d: "M393.88 37c7.246 0 13.12 5.104 13.12 11.4s-5.874 11.4-13.12 11.4h-74.97c7.246 0 13.12 5.104 13.12 11.4s-5.874 11.4-13.12 11.4h41.234c7.246 0 13.119 5.104 13.119 11.4s-5.873 11.4-13.119 11.4h-19.069c-9.136 0-16.542 5.104-16.542 11.4q0 6.295 11.245 11.4c7.246 0 13.12 5.104 13.12 11.4s-5.874 11.4-13.12 11.4H180.216c-7.246 0-13.12-5.104-13.12-11.4s5.874-11.4 13.12-11.4H107.12c-7.246 0-13.12-5.104-13.12-11.4s5.874-11.4 13.12-11.4h74.97c7.246 0 13.12-5.104 13.12-11.4s-5.874-11.4-13.12-11.4h-46.856c-7.246 0-13.12-5.104-13.12-11.4s5.874-11.4 13.12-11.4h74.97c-7.246 0-13.12-5.104-13.12-11.4s5.874-11.4 13.12-11.4zm0 45.6c7.246 0 13.12 5.104 13.12 11.4s-5.874 11.4-13.12 11.4-13.12-5.104-13.12-11.4 5.874-11.4 13.12-11.4",
  clipRule: "evenodd",
  style: {
    fill: "#f7f8fa",
    fill: "color(display-p3 .9702 .9735 .98)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#476CFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 0.1,
  strokeWidth: 7.5,
  d: "M440.403 61h-13.865m24.591-23H422zM463 38h-3.767zM160 175h-16.917m7.242-26h-35.539zm-47.591 0H94z",
  style: {
    stroke: "#476cff",
    stroke: "color(display-p3 .2784 .4235 1)",
    strokeOpacity: 0.1
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#476CFF",
  fillOpacity: 0.24,
  d: "m284.095 110.847 12.849 12.846-4.245 4.245-12.846-12.849a26.88 26.88 0 0 1-16.851 5.907c-14.904 0-27-12.096-27-27s12.096-27 27-27 27 12.096 27 27a26.88 26.88 0 0 1-5.907 16.851m-6.018-2.226a20.93 20.93 0 0 0 5.925-14.625c0-11.604-9.399-21-21-21-11.604 0-21 9.396-21 21 0 11.601 9.396 21 21 21a20.93 20.93 0 0 0 14.625-5.925zm-11.541-26.097a6 6 0 0 0-3.258 7.255 6 6 0 0 0 6.805 4.116 6 6 0 0 0 4.391-3.433 12 12 0 1 1-7.938-7.938",
  style: {
    fill: "#476cff",
    fill: "color(display-p3 .2784 .4235 1)",
    fillOpacity: 0.24
  }
}));
export { SvgNotFound as ReactComponent };
export default __webpack_public_path__ + "ed4aaa2aee7509e2c83fbf22e8234b6d.svg";